import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-be9572a2")

_pushScopeId("data-v-be9572a2")
const _hoisted_1 = { class: "pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "px-5" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "pt-8" }
const _hoisted_5 = { class: "flex flex-row justify-between mb-6" }
const _hoisted_6 = { class: "flex flex-col gap-4 w-1/2" }
const _hoisted_7 = { class: "flex flex-col gap-4 w-1/2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "w-4/5" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_9 = { class: "pt-8" }
const _hoisted_10 = { class: "pt-8" }
const _hoisted_11 = { class: "flex flex-row justify-between mb-6" }
const _hoisted_12 = { class: "flex flex-col gap-4 w-1/2" }
const _hoisted_13 = { class: "flex flex-col gap-4 w-1/2" }
const _hoisted_14 = { class: "table-stt" }
const _hoisted_15 = { class: "flex flex-col gap-6" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = { class: "text-sm text-gray-lp-500" }
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_19 = { class: "flex flex-col" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb),
    _createVNode(_component_DetailLayout, {
      title: `STI Manifest - ${_ctx.id}`,
      error: _ctx.isError,
      "error-type": _ctx.errorCause,
      "on-try-again": _ctx.fetchDetail,
      loading: _ctx.controller.isLoading,
      "on-back": 
        () => {
          _ctx.$router.push({ name: 'STI' });
        }
      
    }, {
      data: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Title, {
              label: _ctx.$t('processSti.shippingDetail')
            }, null, 8, ["label"]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('processSti.originCity'),
                    value: _ctx.detailData.originConsolidator
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('processSti.podSoon'),
                    value: _ctx.detailData.totalStatusReturnPod || '0'
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('processSti.stiDestination'),
                    value: _ctx.detailData.totalStiDest || '0'
                  }, null, 8, ["label", "value"])
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('processSti.rtsSoon'),
                    value: _ctx.detailData.totalStatusReturnRts || '0'
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('processSti.halSoon'),
                    value: _ctx.detailData.totalStatusReturnHal || '0'
                  }, null, 8, ["label", "value"])
                ])
              ])
            ])
          ]),
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Title, {
              label: _ctx.$t('processSti.sttDetail')
            }, null, 8, ["label"]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('processSti.totalStt'),
                    value: _ctx.detailData.totalStt || '0'
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('processSti.totalGrossWeight'),
                    value: _ctx.formatWeight(_ctx.detailData.totalGrossWeight)
                  }, null, 8, ["label", "value"])
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('processSti.totalKoli'),
                    value: _ctx.detailData.totalPiece || '0'
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('processSti.totalVolumeWeight'),
                    value: _ctx.formatWeight(_ctx.detailData.totalVolumeWeight)
                  }, null, 8, ["label", "value"])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_TableV2, {
            class: "mt-0",
            columns: _ctx.columns,
            data: _ctx.controller.STIReverseScanDetailData.stt,
            loading: _ctx.controller.isLoading,
            "border-top": false,
            "total-column-freeze": 2,
            "is-pinned-scroll-bottom": true,
            "hide-pagination": true,
            "on-try-again": _ctx.fetchDetail,
            "pinned-substract-height": "300px"
          }, null, 8, ["columns", "data", "loading", "on-try-again"])
        ])
      ]),
      "sub-data": _withId(() => [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('processSti.createdDate'),
              value: _ctx.formatDate(_ctx.detailData.stiDate)
            }, null, 8, ["label", "value"]),
            _createVNode("span", _hoisted_17, _toDisplayString(_ctx.detailData.createdName || "-"), 1)
          ]),
          _hoisted_18,
          _createVNode("div", _hoisted_19, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('processSti.printStiDest'),
              class: "print-buttons"
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_button, {
                  color: "white",
                  "text-color": "gray-lp-300 mb-2 mt-4",
                  "custom-class": "text-left",
                  title: _ctx.$t('sti.printRingkasan'),
                  onClick: _ctx.printSummary,
                  "icon-left": "print-summary"
                }, null, 8, ["title", "onClick"]),
                _createVNode(_component_lp_button, {
                  title: _ctx.$t('sti.printPdf'),
                  color: "white",
                  "text-color": "gray-lp-300",
                  onClick: _ctx.printManifest,
                  "custom-class": "text-left",
                  "icon-left": "printer"
                }, null, 8, ["title", "onClick"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "error", "error-type", "on-try-again", "loading", "on-back"])
  ]))
})